import { IStoreCurrency } from "@modules/common/model/domain/store-currency";
import { IResponse } from "@core/data-access/model";
import { AbstractAccessorService, IDataAccessor } from "@core/data-access";
import { IStoreCurrencyRestService } from "./store-currency-rest";


/**
 * @description 根据店铺类型获取店铺中使用的货币信息
 */
export class StoreCurrencyRestService extends AbstractAccessorService<IStoreCurrency> implements IStoreCurrencyRestService {

    public readonly $name: string = "storeCurrencyRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IStoreCurrency>) {
        super();
    }


    /**
     * @description 获取指定id的PropertyModel
     * @param propertryModelId 
     */
    public default(storeId: string): angular.IPromise<IResponse<IStoreCurrency>> {
        return this.$accessor<IStoreCurrency, { storeId: string }, string>(this.$name, "default", {
            parameter: {
                storeId: storeId
            }
        })
    }
}